export default __webpack_public_path__ + "static/107987-24b9054587cdef666a023cd72ca318f1.jpg";